// src/pages/Appli/AppliAdmin/VisitorCenter/ui/VisitorCenterUi.jsx

import React from "react";

import {
  FiAlertCircle,
  FiInbox,
  FiLoader,
} from "react-icons/fi";

import {
  VISITOR_STATUS_CONFIG,
} from "../data/visitorCenterData";

export function SectionCard({
  title,
  subtitle,
  action,
  children,
  className = "",
}) {
  return (
    <section
      className={`overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm ${className}`}
    >
      {(title || subtitle || action) && (
        <header className="flex flex-col gap-3 border-b border-slate-100 px-5 py-5 sm:flex-row sm:items-center sm:justify-between lg:px-6">
          <div>
            {title && (
              <h2 className="text-lg font-extrabold text-[#123B57]">
                {title}
              </h2>
            )}

            {subtitle && (
              <p className="mt-1 text-sm text-slate-500">
                {subtitle}
              </p>
            )}
          </div>

          {action}
        </header>
      )}

      <div>{children}</div>
    </section>
  );
}

export function StatusBadge({ status = "offline" }) {
  const config =
    VISITOR_STATUS_CONFIG[status] ||
    VISITOR_STATUS_CONFIG.offline;

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-2.5 py-1 text-xs font-bold ${config.className}`}
    >
      <span
        className={`h-2 w-2 rounded-full ${config.dotClassName}`}
      />

      {config.label}
    </span>
  );
}

export function LoadingState({
  label = "Chargement...",
  minHeight = "min-h-[220px]",
}) {
  return (
    <div
      className={`flex ${minHeight} items-center justify-center p-6`}
    >
      <div className="text-center text-slate-500">
        <FiLoader className="mx-auto animate-spin text-3xl text-[#2EA7E0]" />
        <p className="mt-3 text-sm font-semibold">{label}</p>
      </div>
    </div>
  );
}

export function EmptyState({
  title = "Aucune donnée",
  description = "Aucun élément ne correspond actuellement à cette vue.",
  icon: Icon = FiInbox,
}) {
  return (
    <div className="flex min-h-[220px] items-center justify-center p-8 text-center">
      <div>
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-[#EEF7FC] text-2xl text-[#2EA7E0]">
          <Icon />
        </div>

        <h3 className="mt-4 font-extrabold text-[#123B57]">
          {title}
        </h3>

        <p className="mx-auto mt-2 max-w-sm text-sm text-slate-500">
          {description}
        </p>
      </div>
    </div>
  );
}

export function ErrorState({ message }) {
  if (!message) return null;

  return (
    <div className="m-5 flex items-start gap-3 rounded-2xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
      <FiAlertCircle className="mt-0.5 shrink-0 text-lg" />
      <span>{message}</span>
    </div>
  );
}

export function Pagination({
  page,
  totalPages,
  onChange,
}) {
  if (!totalPages || totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between border-t border-slate-100 px-5 py-4">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="rounded-xl border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40"
      >
        Précédent
      </button>

      <span className="text-sm font-semibold text-slate-500">
        Page {page} sur {totalPages}
      </span>

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="rounded-xl border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40"
      >
        Suivant
      </button>
    </div>
  );
}